var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.create)?_c('v-col',[_c('v-btn',{attrs:{"depressed":"","width":"100%"},on:{"click":_vm.back}},[_c('span',[_vm._v(_vm._s(_vm._f("t")("action.back")))]),_c('v-icon',[_vm._v("fa fa-arrow-left")])],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }